module.exports = __webpack_public_path__ + "img/Mobile.49e2c083.svg";